import { Component, Input } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';

import { MESSAGE_COMMON_ERROR, MESSAGE_COPY_SUCCESS } from '../message';

@Component({
  selector: 'app-clipboard-copy',
  templateUrl: './clipboard-copy.component.html'
})
export class ClipboardCopyComponent {
  @Input() placeholder: string;
  @Input() value: string;

  constructor(private snackBar: MatSnackBar) { }

  handleSuccess() {
    this.openSnackBar(MESSAGE_COPY_SUCCESS);
  }

  handleError() {
    this.openSnackBar(MESSAGE_COMMON_ERROR);
  }

  private openSnackBar(message: string, action?: string, config?: MatSnackBarConfig) {
    config = Object.assign(new MatSnackBarConfig(), config, { duration: 3000 });
    this.snackBar.open(message, action, config);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/clipboard-copy/clipboard-copy.component.ts